const messages = {
  title: "Magazin",
  description: "Bun venit la magazinul de recompense. Aici vă puteți valorifica punctele Bridgestone Plus <br/> pentru recompense din diferite categorii. Gama de produse <br/> este actualizată în mod regulat. Sperăm să vă bucurați de navigare.",
  sort: {
    asc: "Sortare după: Cel mai mic preț",
    desc: "Sortare după: Cel mai mare preț",
  },
  productSearchBox: {
    from: "puncte de la",
    to: "puncte până la",
  },
  noProducts: "Criteriile de căutare nu au returnat rezultate",
  quantity: "Cantitate",
  search: "Căutare",
  perPage: "Articole pe pagină",
  timeUnavailable: "Momentan indisponibil",
  product: "Produs",
  cart: {
    pointsPerUnit: "Puncte per unitate",
    pointsSum: "Suma punctelor",
  },
  action: "Acțiune",
  pointsTotal: "Total",
  cartRemainPoints: "Puncte rămase în coș",
  shoppingCart: "Coș de cumpărături",
  emptyCart: "Coșul este gol.",
  attributes: "Atribute",
  selectAddressP: "Vă rugăm să selectați adresa de livrare",
  orderDelivery: "Adresă de livrare",
  selectedProducts: "Produse selectate",
  orderSummary: "Prezentare generală a comenzii",
  contactPerson: "Persoană de contact",
  selectedAddress: "Adresă selectată",
  order: {
    success: "Vă mulțumim! Comanda dvs. a fost plasată cu succes. Veți primi confirmarea comenzii în căsuța poștală în câteva minute.",
    description: "Aici veți găsi o prezentare generală a comenzilor din magazinul de recompense.",
    info: "Aici veți găsi o prezentare generală a comenzilor din magazinul de recompense.",
    date: "Data comenzii",
    number: "Nr. comandă",
    status: {
      created: "Creată",
      confirm_order: "Confirmă comanda",
      ready_for_shipment: "Pregătită pentru expediere",
      rejected: "Respinsă",
      processed: "Procesată",
      shipped: "Expediată",
      returned: "Returnată",
      finished: "Finalizată",
    },
    anyOrder: "Nicio comandă",
    products: "Produse",
    quantity_short: "buc.",
    itemRemoved: "nu poate fi livrat",
  },
  orders: "Comenzi",
  notEnoughPoints: "Nu aveți suficiente puncte disponibile.",
  statusText: "Stare",
  outOfStock: "Momentan nu este în stoc",
  productUnavailable: "Acest produs nu mai este disponibil.",
  deletedProductsTitle: "Produsele nu mai sunt disponibile",
  deletedProductsMessage: "Următoarele produse nu mai sunt disponibile. Eliminați-le din coș pentru a continua.",
  removeSelected: "Elimină selecția",
  clearCart: "Golește coșul",
  removeSelectedConfirm: "Eliminați produsele selectate din coș?",
  clearCartConfirm: "Eliminați toate produsele din coș?",
  incompleteAddress: {
    firstName: "Vă rugăm să adăugați un prenume la adresa de livrare",
    lastName: "Vă rugăm să adăugați un nume la adresa de livrare",
    company: "Vă rugăm să adăugați un nume de companie la adresa de livrare",
    street: "Vă rugăm să adăugați o stradă și un număr la adresa de livrare",
    postalCode: "Vă rugăm să adăugați un cod poștal la adresa de livrare",
    city: "Vă rugăm să adăugați un oraș la adresa de livrare",
    country: "Vă rugăm să adăugați o țară la adresa de livrare",
    phone: "Vă rugăm să adăugați un număr de telefon la adresa de livrare",
  },
  placeOrder: "Comandă fermă",
  toOrderDelivery: "Continuați la adresa de livrare",
  toOrderSummary: "La prezentarea comenzii",
  productImg: "Imagine produs",
  selectAddressBtn: "Alegeți adresa",
  perPgae: "Articole pe pagină",
  categories: {
    advertising: {
      title: "Materiale publicitare",
      desc: "Participați direct aici pe platformă și obțineți <br/> 40 de puncte extra pentru clubul de recompense.",
    },
    rewards: {
      title: "Recompense exclusive",
      desc: "Descoperiți oferta bonus în centrul nostru de training sau la sediul dvs.",
    },
    tools: {
      title: "Unelte de atelier",
      desc: "Folosiți punctele pentru traininguri terțe <br/> și reduceți costurile.",
    },
    trainings: {
      title: "Traininguri și cursuri",
      desc: "Descoperiți oferta bonus în centrul nostru de training sau la sediul dvs.",
    },
    salesroom: {
      title: "Spațiu de vânzare",
      desc: "Amenajați spațiul de vânzare și oferiți clienților o ședere plăcută.",
    },
    hunter: {
      title: "Hunter",
      desc: "Schimbați puncte pentru echipamente de atelier Hunter atractive.",
    },
  },
  bestSold: "Cele mai vândute",
  seasonal: "Sezonier",
  affordable: "Aproape gata",
  forPoints: "pentru {points} puncte",
  reachedPoints: "Punctele necesare atinse",
  remainingPoints: "Mai lipsesc {points} puncte",
  favoriteProducts: {
    description: "Aici veți găsi produsele salvate.",
  },
  categoryPageDescriptionFallback: "Materiale pentru atelier sau alte produse de calitate cu logo-ul Bridgestone pentru afacerea dvs.",
  variant: "Variante selectabile",
};
export default {
  messages,
};
